// Types de produits cosmétiques
export const PRODUCT_CATEGORIES = [
  { value: 'all', label_fr: 'Tous', label_en: 'All' },
  { value: 'cleanser', label_fr: 'Nettoyant', label_en: 'Cleanser' },
  { value: 'serum', label_fr: 'Sérum', label_en: 'Serum' },
  { value: 'moisturizer', label_fr: 'Hydratant', label_en: 'Moisturizer' },
  { value: 'sunscreen', label_fr: 'Solaire', label_en: 'Sunscreen' },
  { value: 'treatment', label_fr: 'Traitement', label_en: 'Treatment' },
  { value: 'exfoliant', label_fr: 'Exfoliant / Gommage', label_en: 'Exfoliant / Scrub' },
  { value: 'mask', label_fr: 'Masque', label_en: 'Mask' },
  { value: 'toner', label_fr: 'Lotion / Tonique', label_en: 'Toner' },
  { value: 'eye_care', label_fr: 'Contour des yeux', label_en: 'Eye Care' },
  { value: 'body', label_fr: 'Corps', label_en: 'Body' },
];

// Types d'affections / préoccupations cutanées
export const SKIN_CONCERNS = [
  { value: 'all', label_fr: 'Toutes', label_en: 'All' },
  { value: 'oily_skin', label_fr: 'Peau grasse', label_en: 'Oily Skin' },
  { value: 'dry_skin', label_fr: 'Peau sèche', label_en: 'Dry Skin' },
  { value: 'combination_skin', label_fr: 'Peau mixte', label_en: 'Combination Skin' },
  { value: 'sensitive_skin', label_fr: 'Peau sensible', label_en: 'Sensitive Skin' },
  { value: 'acne', label_fr: 'Acné', label_en: 'Acne' },
  { value: 'dark_spots', label_fr: 'Taches pigmentaires', label_en: 'Dark Spots' },
  { value: 'anti_aging', label_fr: 'Anti-âge / Rides', label_en: 'Anti-aging / Wrinkles' },
  { value: 'sun_protection', label_fr: 'Protection solaire', label_en: 'Sun Protection' },
  { value: 'dehydration', label_fr: 'Déshydratation', label_en: 'Dehydration' },
  { value: 'redness', label_fr: 'Rougeurs', label_en: 'Redness' },
  { value: 'dull_skin', label_fr: 'Teint terne', label_en: 'Dull Skin' },
  { value: 'pores', label_fr: 'Pores dilatés', label_en: 'Large Pores' },
  { value: 'uneven_tone', label_fr: 'Teint irrégulier', label_en: 'Uneven Tone' },
];

// Catégories de compléments alimentaires
export const SUPPLEMENT_CATEGORIES = [
  { value: 'all', label_fr: 'Tous', label_en: 'All' },
  { value: 'zinc', label_fr: 'Zinc', label_en: 'Zinc' },
  { value: 'vitamin_c', label_fr: 'Vitamine C', label_en: 'Vitamin C' },
  { value: 'vitamin_d', label_fr: 'Vitamine D', label_en: 'Vitamin D' },
  { value: 'vitamin_e', label_fr: 'Vitamine E', label_en: 'Vitamin E' },
  { value: 'vitamin_b', label_fr: 'Vitamines B', label_en: 'B Vitamins' },
  { value: 'collagen', label_fr: 'Collagène', label_en: 'Collagen' },
  { value: 'omega3', label_fr: 'Oméga-3', label_en: 'Omega-3' },
  { value: 'multivitamin', label_fr: 'Multivitamines', label_en: 'Multivitamins' },
  { value: 'magnesium', label_fr: 'Magnésium', label_en: 'Magnesium' },
  { value: 'probiotics', label_fr: 'Probiotiques', label_en: 'Probiotics' },
  { value: 'hair_nails', label_fr: 'Cheveux & Ongles', label_en: 'Hair & Nails' },
  { value: 'antioxidants', label_fr: 'Antioxydants', label_en: 'Antioxidants' },
];

// Recommandations de compléments par affection
export const SUPPLEMENT_RECOMMENDATIONS = {
  oily_skin: ['zinc', 'vitamin_b', 'probiotics'],
  dry_skin: ['omega3', 'vitamin_e', 'collagen'],
  combination_skin: ['zinc', 'omega3', 'multivitamin'],
  sensitive_skin: ['omega3', 'probiotics', 'vitamin_d'],
  acne: ['zinc', 'vitamin_b', 'probiotics', 'vitamin_d'],
  dark_spots: ['vitamin_c', 'vitamin_e', 'antioxidants'],
  anti_aging: ['collagen', 'vitamin_c', 'vitamin_e', 'omega3', 'antioxidants'],
  sun_protection: ['vitamin_d', 'vitamin_c', 'antioxidants'],
  dehydration: ['omega3', 'collagen', 'vitamin_e'],
  redness: ['omega3', 'probiotics', 'vitamin_d'],
  dull_skin: ['vitamin_c', 'vitamin_e', 'multivitamin'],
  pores: ['zinc', 'vitamin_b'],
  uneven_tone: ['vitamin_c', 'vitamin_e', 'antioxidants'],
};

// Recommandations de consommables par affection
export const CONSUMABLE_RECOMMENDATIONS = {
  all: ['cotton', 'eponge', 'gant'],
  oily_skin: ['cotton', 'papier_matifiant', 'eponge'],
  dry_skin: ['cotton', 'gant_doux', 'eponge_konjac'],
  sensitive_skin: ['coton_bio', 'eponge_konjac', 'lingette_douce'],
  acne: ['cotton', 'compresse', 'papier_matifiant'],
};

// Helpers pour obtenir les labels
export const getCategoryLabel = (value, language) => {
  const cat = PRODUCT_CATEGORIES.find(c => c.value === value);
  return cat ? (language === 'fr' ? cat.label_fr : cat.label_en) : value;
};

export const getConcernLabel = (value, language) => {
  const concern = SKIN_CONCERNS.find(c => c.value === value);
  return concern ? (language === 'fr' ? concern.label_fr : concern.label_en) : value;
};

export const getSupplementCategoryLabel = (value, language) => {
  const cat = SUPPLEMENT_CATEGORIES.find(c => c.value === value);
  return cat ? (language === 'fr' ? cat.label_fr : cat.label_en) : value;
};

// Vérifier si un produit correspond à une affection
export const productMatchesConcern = (product, concern) => {
  if (concern === 'all') return true;
  
  const concernMappings = {
    oily_skin: ['oily', 'grasse', 'sebum', 'matifiant', 'purifiant'],
    dry_skin: ['dry', 'sèche', 'seche', 'hydratant', 'nourrissant', 'lipid'],
    combination_skin: ['mixte', 'combination', 'équilibrant'],
    sensitive_skin: ['sensitive', 'sensible', 'apaisant', 'calm', 'doux'],
    acne: ['acne', 'acné', 'bouton', 'imperfection', 'purifiant', 'cleanance', 'sebium'],
    dark_spots: ['tache', 'spot', 'pigment', 'éclaircissant', 'unifiant', 'vitamine c', 'niacinamide'],
    anti_aging: ['ride', 'wrinkle', 'anti-age', 'anti-âge', 'raffermissant', 'collagène', 'retinol', 'lift'],
    sun_protection: ['solaire', 'spf', 'uv', 'sun', 'protection'],
    dehydration: ['hydrat', 'déshydrat', 'eau', 'aqua', 'moisture'],
    redness: ['rougeur', 'redness', 'couperose', 'rosacée', 'apaisant'],
    dull_skin: ['éclat', 'radiance', 'glow', 'vitamine c', 'lumineux'],
    pores: ['pore', 'resserrant', 'astringent', 'exfoliant'],
    uneven_tone: ['unifiant', 'teint', 'tone', 'éclat'],
  };

  const keywords = concernMappings[concern] || [];
  const searchText = `${product.name} ${product.description || ''} ${product.main_ingredient || ''} ${(product.target_concerns || []).join(' ')}`.toLowerCase();
  
  return keywords.some(keyword => searchText.includes(keyword.toLowerCase()));
};

// Get recommended supplement categories based on concern
export const getRecommendedSupplementCategories = (selectedConcern) => {
  if (selectedConcern === 'all') return [];
  return SUPPLEMENT_RECOMMENDATIONS[selectedConcern] || [];
};

// Get recommended consumable types based on concern
export const getRecommendedConsumableTypes = (selectedConcern) => {
  if (selectedConcern === 'all') return CONSUMABLE_RECOMMENDATIONS.all;
  return CONSUMABLE_RECOMMENDATIONS[selectedConcern] || CONSUMABLE_RECOMMENDATIONS.all;
};
